import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const RoleGuard = ({ children, allowedRoles }) => {
    const token = localStorage.getItem('token');

    if (!token) return <Navigate to="/login" replace />;

    try {
        const decoded = jwtDecode(token);
        const userRole = decoded.role?.toUpperCase() || 'USER';

        // ⚔️ Se a patente do usuário estiver na lista permitida, ele passa.
        if (allowedRoles.includes(userRole)) {
            return children;
        }

        // 🚩 Se não tiver permissão, volta para o Dashboard com um aviso (opcional)
        return <Navigate to="/dashboard" replace />;
    } catch (error) {
        return <Navigate to="/login" replace />;
    }
};

export default RoleGuard;